import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import I18NextVue from 'i18next-vue'
import { initI18n } from 'www/utils'
import LpuAccessibilityGallery from 'www/vue_components/common/LpuAccessibilityGallery/LpuAccessibilityGallery.vue'
import 'www/vue_components/common/LpuAccessibilityGallery/index.scss'

const mountElement = document.querySelector('.vue-mount-lpu-accessibility-gallery')

async function initLpuGallery() {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/LpuAccessibilityGallery' })

  Vue.use(I18NextVue, { i18next })

  if (mountElement) {
    new Vue({
      vuetify,
      el: mountElement,
      components: {
        LpuAccessibilityGallery,
      },
    })
  }
}

initLpuGallery()
